export default __webpack_public_path__ + "static/media/arrow-down.7681f6e6.svg";